export enum Environment {
  Prod = 'Prod',
  Staging = 'Staging',
  Local = 'Local',
}

/*
Access type enum repressents how the application is accessed from the web.
 *  - Direct - represents `*.vpsvc.com` or `localhost`
 *  - Proxy - represents `www.vistaprint.*`, `next.vistaprint.*`, `staging.vistparint.*`
 *  - None - either SSR or error state
*/
export enum AccessType {
  Direct = 'Direct',
  Proxy = 'Proxy',
  None = 'None',
}

export interface RuntimeContext {
  environment: Environment;
  accessType: AccessType;
}
